import { httpService } from '~/Services/Service';

export const pesquisar = (filtros) =>
  httpService.post('/declaracao-quitacao/pesquisar', filtros);

export const emitir = (payload) =>
  httpService.post('/declaracao-quitacao/emitir', payload);

export const sugerirPeriodo = () =>
  httpService.get('/declaracao-quitacao/sugerir-periodo');

export const listarGruposEmpresa = () =>
  httpService.get('/declaracao-quitacao/grupos-empresa');

export const listarFamilias = (codigoGrupoEmpresa) =>
  httpService.get('/declaracao-quitacao/familias', {
    params: { codigo_grupo_empresa: codigoGrupoEmpresa },
  });

export const listarContas = (codigoGrupoEmpresa, busca) =>
  httpService.get('/declaracao-quitacao/contas', {
    params: { codigo_grupo_empresa: codigoGrupoEmpresa, busca },
  });
